import React from 'react';
import { Modal, Box, Grid } from '@mui/material';
import { Formik, Form } from 'formik';
import CustomInput from '../../CustomInput';
import CustomButton from '../../CustomButton';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 600,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
  maxHeight: '90vh',
  overflowY: 'auto'
};

const EditModal = ({
  open,
  onClose,
  onSubmit,
  initialValues,
  validationSchema,
  fields,
  title,
  isLoading
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <h2 style={{ marginBottom: '20px' }}>{title || 'Edit Contact'}</h2>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({ values, handleChange, errors, touched }) => (
            <Form>
              <Grid container spacing={2}>
                {fields.map((field) => (
                  <Grid
                    item
                    xs={12}
                    md={field.width?.md || 12}
                    key={field.key}
                  >
                    <CustomInput
                      name={field.key}
                      label={field.label}
                      type={field.type}
                      placeholder={field.placeholder}
                      value={values[field.key]}
                      onChange={handleChange}
                      required={field.required}
                      error={touched[field.key] && Boolean(errors[field.key])}
                      helperText={touched[field.key] && errors[field.key]}
                      options={field.options || []}
                      height={field.height}
                    />
                  </Grid>
                ))}
              </Grid>
              <Box display="flex" justifyContent="flex-end" mt={4} gap={2}>
                {/* <Button onClick={onClose}>Cancel</Button> */}
                <CustomButton text={"Cancel"} bgcolor={'gray'} color={'black'} onClick={onClose}/>
                <CustomButton text={isLoading ? 'Updating...' : 'Update'} bgcolor={'#95ABEB'} color={'black'} type={'submit'} width={'30%'} disabled={isLoading}/>
                  {/* Update
                </Button> */}
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};

export default EditModal;
